import {
  RESEND_TWO_FACTOR_AUTH_CODE,
  RECEIVE_TWO_FACTOR_AUTH_CODE,
  REQUEST_VALIDATE_TWO_FACTOR_AUTH_CODE,
  SUCCESS_VALIDATE_TWO_FACTOR_AUTH_CODE,
  TWO_FACTOR_AUTH_CODE_VALIDATION_FEEDBACK,
  REQUEST_ENABLE_TWO_FACTOR_AUTH_METHODS,
  RECEIVE_ENABLE_TWO_FACTOR_AUTH_METHODS,
  REQUEST_DISABLE_TWO_FACTOR_AUTH_METHODS,
  RECEIVE_DISABLE_TWO_FACTOR_AUTH_METHODS,
  GENERATE_TWO_FACTOR_AUTH_CODE_REQUEST,
  GENERATE_TWO_FACTOR_AUTH_CODE_SUCCESS,
} from '@/redux/actions/actionsTypes';

export const initialState = {
  loadingCodeGeneration: false,
  loadingMethods: false,
  loadingResend: false,
  loadingValidate: false,
  validationError: false,
  data: {},
  methodsData: [],
  selectedMethodData: {},
  nextCodeCanBeGeneratedAt: null,
  isSent: false,
};

export default function twoFactorAuth(state = initialState, action) {
  switch (action.type) {
    case GENERATE_TWO_FACTOR_AUTH_CODE_REQUEST:
      return {
        ...state,
        loadingCodeGeneration: true,
      };
    case GENERATE_TWO_FACTOR_AUTH_CODE_SUCCESS:
      return {
        ...state,
        loadingCodeGeneration: false,
        nextCodeCanBeGeneratedAt: action.payload.nextCodeCanBeGeneratedAt,
        isSent: action.payload.isSent,
        selectedMethodData: action.payload.method,
      };
    case REQUEST_ENABLE_TWO_FACTOR_AUTH_METHODS:
      return {
        ...state,
        loadingMethods: true,
      };
    case RECEIVE_ENABLE_TWO_FACTOR_AUTH_METHODS:
      return {
        ...state,
        loadingMethods: false,
        methodsData: action.payload.methods,
      };
    case REQUEST_DISABLE_TWO_FACTOR_AUTH_METHODS:
      return {
        ...state,
        loadingMethods: true,
      };
    case RECEIVE_DISABLE_TWO_FACTOR_AUTH_METHODS:
      return {
        ...state,
        loadingMethods: false,
        methodsData: action.payload.methods,
      };
    case RESEND_TWO_FACTOR_AUTH_CODE:
      return {
        ...state,
        loadingResend: true,
      };
    case RECEIVE_TWO_FACTOR_AUTH_CODE:
      return {
        ...state,
        loadingResend: false,
        nextCodeCanBeGeneratedAt: action.payload.nextCodeCanBeGeneratedAt,
        isSent: action.payload.isSent,
        selectedMethodData: action.payload.method,
      };
    case REQUEST_VALIDATE_TWO_FACTOR_AUTH_CODE:
      return {
        ...state,
        loadingValidate: true,
      };
    case SUCCESS_VALIDATE_TWO_FACTOR_AUTH_CODE:
      return {
        ...state,
        data: action.payload,
      };
    case TWO_FACTOR_AUTH_CODE_VALIDATION_FEEDBACK:
      return {
        ...state,
        validationError: action.payload.hasError,
        loadingValidate: false,
      };
    default:
      return state;
  }
}
